
import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFunctions, httpsCallable, connectFunctionsEmulator } from 'firebase/functions';


// Ihre definierte Konfiguration
const firebaseConfig = {
  // Bitte beachten: In einem echten Projekt sollten diese Werte aus Umgebungsvariablen geladen werden.
  apiKey: "AIzaSyCrRqAP_vRjFB7tx3f1gO_pyyycTFEl-KU", 
  authDomain: "meetform25.firebaseapp.com",
  projectId: "meetform25",
  storageBucket: "meetform25.appspot.com",
  messagingSenderId: "993332539439",
   appId: "1:993332539439:web:ab4064d2e90f2855c196da"
  // Füge useEmulators hinzu, um die Emulatorverbindung zu steuern (optional)
  // useEmulators: window.location.hostname === 'localhost' 
};

// =======================================================
// INITIALISIERUNG
// =======================================================

// Firebase initialisieren
const app = initializeApp(firebaseConfig);
// WICHTIG: Region muss mit der Backend-Bereitstellung übereinstimmen (europe-west1 ist hier der Standard)
const functions = getFunctions(app, 'europe-west1'); 
const db = getFirestore(app);
const auth = getAuth(app);

// Emulator-Verbindungen (nur für lokale Entwicklung)
// (Stelle sicher, dass 'useEmulators' in deiner public/firebase-config.js gesetzt ist, wenn du lokal testest)
if (window.location.hostname === 'localhost' && firebaseConfig.useEmulators) {
  console.log("Firebase: Verbinde mit Emulatoren...");
  // Stelle sicher, dass die Ports mit deiner firebase.json übereinstimmen
  connectAuthEmulator(auth, "http://localhost:9099");
  connectFirestoreEmulator(db, "localhost", 8080);
  connectFunctionsEmulator(functions, "localhost", 5001);
}


// =======================================================
// CALLABLE FUNCTIONS DEFINITION
// (Muss nach der Definition von 'functions' erfolgen)
// =======================================================

// Bestehende Callable Functions
const getGlobalStatsCallable = httpsCallable(functions, 'getGlobalStats');
const registerUserCallable = httpsCallable(functions, 'registerUser');
const createCompanyCallable = httpsCallable(functions, 'createCompany');
const getCustomClaimsCallable = httpsCallable(functions, 'getCustomClaims');
const updateUserProfileCallable = httpsCallable(functions, 'updateUserProfile');
const checkCompanyIdAvailabilityCallable = httpsCallable(functions, 'checkCompanyIdAvailability');
const requestCompanyAccountCallable = httpsCallable(functions, 'requestCompanyAccount');
const getMeetingByInviteTokenCallable = httpsCallable(functions, 'getMeetingByInviteToken');
const sendGuestMeetingInvitesCallable = httpsCallable(functions, 'sendGuestMeetingInvites');
const requestPasswordResetCallable = httpsCallable(functions, 'requestPasswordReset');
const setSuperAdminClaimCallable = httpsCallable(functions, 'setSuperAdminClaim'); 
const getAllCompaniesAndUsersCallable = httpsCallable(functions, 'getAllCompaniesAndUsers'); 
const markMeetingNotificationsAsReadCallable = httpsCallable(functions, 'markMeetingNotificationsAsRead');
const getExternalMeetingDetailsCallable = httpsCallable(functions, 'getExternalMeetingDetails');
const getNextMeetingNumber = httpsCallable(functions, 'getNextMeetingNumber');
const getNextTaskNumber = httpsCallable(functions, 'getNextTaskNumber');
const proposeAgendaItemCallable = httpsCallable(functions, 'proposeAgendaItem');
const reviewAgendaItemCallable = httpsCallable(functions, 'reviewAgendaItem');

// === NEUE FUNKTIONEN FÜR i18n-Übersetzer-Portal ===
const createTranslationJobCallable = httpsCallable(functions, 'createTranslationJob');
const getTranslationJobDataCallable = httpsCallable(functions, 'getTranslationJobData');
const submitTranslationCallable = httpsCallable(functions, 'submitTranslation');
const cancelTranslationJobCallable = httpsCallable(functions, 'cancelTranslationJob');

// === NEU: KALENDER IMPORT FUNKTION ===
const fetchExternalCalendarEventsCallable = httpsCallable(functions, 'fetchExternalCalendarEvents');


// =======================================================
// EXPORTS
// =======================================================

export {
  app,
  db,
  auth,
  functions,
  
  // Alle bestehenden Exporte
  registerUserCallable,
  createCompanyCallable,
  getCustomClaimsCallable,
  updateUserProfileCallable,
  getGlobalStatsCallable,
  checkCompanyIdAvailabilityCallable,
  requestCompanyAccountCallable,
  getMeetingByInviteTokenCallable,
  sendGuestMeetingInvitesCallable,
  requestPasswordResetCallable,
  setSuperAdminClaimCallable,
  getAllCompaniesAndUsersCallable,
  markMeetingNotificationsAsReadCallable,
  getExternalMeetingDetailsCallable,
  getNextMeetingNumber,
  getNextTaskNumber,
  proposeAgendaItemCallable,
  reviewAgendaItemCallable,

  // === NEUE EXPORTE FÜR i18n ===
  createTranslationJobCallable,
  getTranslationJobDataCallable,
  submitTranslationCallable,
  cancelTranslationJobCallable,

  // === NEU: KALENDER IMPORT ===
  fetchExternalCalendarEventsCallable // <--- WICHTIG: Hier exportieren!
};